import React from 'react';
import buttons from 'style/buttons.module.scss';
import styles from './index.module.scss';

// interface IProps {
//   currentEmail: string;
// }

const CloseAccount: React.FC = () => {
  return (
    <>
      <div className={`${styles.deleteAccount} ${styles.changeField}`}>
        <div>
          <span>Close Account</span>
          <p>Delete your account and account data</p>
        </div>
        <button type="submit" className={buttons.buttonOrange}>
          Save Changes
        </button>
      </div>
    </>
  );
};
export default CloseAccount;
